import { User } from 'api/models';
import { getRandomColor } from 'utils/get-random-color';
import { getUserLabel } from 'utils/get-user-label';
import { UserOption } from './types';

export const userOption = (user: User): UserOption => {
  return {
    label: getUserLabel(user),
    value: user.userId,
    imageUrl: user.photoUrl,
    description: user.role?.roleName,
    logoUrl: user.company?.companyLogoUrl,
    color: getRandomColor(user.userId),
    roleId: user.role?.roleId,
    emailId: user.emailId,
    userTimeOffDetails: user?.userTimeOffDetails,
    extra: {
      id: user.userId,
      type: 'user',
      userType: user.userType,
    },
  };
};
